// CurrencyDescription组件翻译
export default {
  // 多币种画布说明
  multi: {
    description:
      "多币种画布提供更高的自由度，专为复杂分析场景设计，支持在同一画布中同时分析多链、多币种的地址和交易数据。",
    supportData: "支持数据",
    supportDetails:
      "Ethereum、BSC链的全币种数据，可通过代币合约精准搜索目标币种。Tron链支持TRX、USDT。",
  },

  // 单币种画布说明
  single: {
    description:
      "单币种画布操作便捷高效，专注于单一链上的单一币种分析，支持一键生成Xmind文件。",
    supportData: "支持数据",
    supportDetails:
      "Ethereum、BSC链的全币种数据，可通过代币合约精准搜索目标币种。Tron链支持TRX、USDT。BITCOIN链仅支持BTC。",
  },
};
